import { languages, MappedGlobalLanguage } from '../configs/env';

export function getLanguageFromPathname(pathname: string): MappedGlobalLanguage | undefined {
    const urlLanguageCode = (pathname.match(/^\/([a-z]{2})(\/|$)/) || [])[1];
    if (!urlLanguageCode) {
        return undefined;
    }

    const languageEntry = Object.values(languages).find((language) => !!language && language.languageCode === urlLanguageCode);
    return languageEntry;
}
